// extracted by mini-css-extract-plugin
export default {"small-container":"ya1uG","smallContainer":"ya1uG"};